import React from "react";
import { Backdrop, CircularProgress, Box, Typography } from "@mui/material";

const Loader = ({ open, message = "Loading..." }) => {
    return (
        <Backdrop
            open={open}
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                color: "#fff",
                backgroundColor: "rgba(0, 0, 0, 0.7)", // Dim background
            }}
        >
            <Box display="flex" flexDirection="column" alignItems="center">
                <CircularProgress color="inherit" />
                {message && (
                    <Typography
                        variant="body1"
                        sx={{
                            mt: 2,
                            color: "white",
                            fontFamily: "PRe",
                            textAlign: "center",
                        }}
                    >
                        {message}
                    </Typography>
                )}
            </Box>
        </Backdrop>
    );
};

export default Loader;
